import type { FaqItem } from '../../types/faq-item';

/**
 * Builds schema.org FAQPage JSON-LD from visible on-page FAQs (keep copy in sync with the page).
 */
export function buildFaqPageSchema(items: readonly FaqItem[]): Record<string, unknown> {
  return {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: items.map((item) => ({
      '@type': 'Question',
      name: item.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: item.answer,
      },
    })),
  };
}
